<template>
  <AkAlert type="info">
    <p>
      {{
        $t(
          'thank-you.bank-transfer.alert.paragraph1'
        )
      }}
    </p>
    <p>
      <i18n-t keypath="We invite you to check the evolution of the order status {0}.">
        <a
          href="/account/orders"
          class="ds-underline"
        >
          {{ $t('in your account, in the “Orders” section') }}
        </a>
      </i18n-t>
    </p>
  </AkAlert>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AlertThankYouValidatedBankTransfer',
});
</script>
